// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "NavList-module--wrapper--295XC";
export var horizontalList = "NavList-module--horizontalList--2uDdX";
export var title = "NavList-module--title--32uil";
export var verticalList = "NavList-module--verticalList--nD6OR";